import { useAuth } from "@/hooks/use-auth";
import { Loader2 } from "lucide-react";
import { Redirect, Route, useLocation } from "wouter";
import { useEffect, useState } from "react";

export function ProtectedRoute({
  path,
  component: Component,
}: {
  path: string;
  component: React.ComponentType<any>;
}) {
  const { user, isLoading } = useAuth();
  const [, navigate] = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  
  useEffect(() => {
    // Só considere a verificação completa quando não estiver mais carregando
    if (!isLoading) {
      setAuthChecked(true);
      
      // Se não houver usuário após a verificação, redirecione
      if (!user) {
        console.log("Usuário não autenticado, redirecionando para /auth");
        navigate("/auth");
      }
    }
  }, [user, isLoading, navigate]);

  // Enquanto verifica autenticação, mostre loading
  if (isLoading || !authChecked) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </Route>
    );
  }

  // Se não há usuário, não renderize o componente (o redirecionamento já foi feito no useEffect)
  if (!user) {
    return <Route path={path}>{() => <Redirect to="/auth" />}</Route>;
  }

  // Se autenticado, renderize o componente normalmente
  return <Route path={path} component={Component} />;
}
